export function getShareLinkSearchRegimeId(pathname) {
    const routeId = getFacilitiesRouteItemId(pathname)
    if (!routeId) return undefined

    const treeId = getRegimeIdFromRouteId(routeId)
    if (treeId) return treeId
    if (routeId.includes("|")) return routeId
    return undefined
}

export function getShareLinkSearchPlaceholder(regimeName) {
    const label = getPlainRegimeName(regimeName)
    if (!label) return "Search facilities, floors, spaces and schedules..."
    return `Search ${label} for facilities, floors, spaces and schedules... `
}

function getFacilitiesRouteItemId(pathname) {
    const parts = pathname.split("/").filter(Boolean).map(decodeURIComponent)
    if (parts[0] !== "app" || parts[1] !== "facilities") return undefined
    if (parts[2] === "facility" || parts[2] === "schedule") return parts[3]
    return parts[2]
}

function getRegimeIdFromRouteId(routeId) {
    if (!routeId.includes("!")) return undefined

    const parts = routeId.split("!")
    const treePart = (parts.at(-2) ?? parts.at(-1)).split("~")[1]
    if (!treePart) return undefined
    return treePart.replaceAll(" ", "|")
}

function getPlainRegimeName(regimeName) {
    return String(regimeName ?? "")
        .replace(/^[^:]+:\s*/, "")
        .trim()
}
